import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { DataResponse } from '../../../app/modules/mdr-dashboards/interfaces/mdr-dashboards.data-response.interface';

interface DataCategory {
    subcategories: string[];
    subcategoriesValues: number[];
}

@Pipe({
    name: 'removeBarEmptyCategories',
    standalone: false,
})
export class RemoveBarEmptyCategoriesPipe implements PipeTransform {
    public subcategoriesValues = new Map<number, number>();

    constructor() {}

    transform(val: Observable<DataResponse>, deep: boolean = false, categories: (string | string[])[]) {
        return isObservable(val)
            ? val.pipe(
                  map((data: DataResponse) => {
                      this.subcategoriesValues.clear();
                      /*Calculate for sub category ( like Recommentation, No Action taken  ) the total amount */
                      /*Then calculate for main category the total amount ( like Risked based, Targeted) */
                      for (let i = 0; i < data.data.length; i++) {
                          for (let j = 0; j < data.data[i].data.length; j++) {
                              if (this.subcategoriesValues.get(j)) {
                                  this.subcategoriesValues.set(j, this.subcategoriesValues.get(j) + data.data[i].data[j]);
                              } else {
                                  this.subcategoriesValues.set(j, data.data[i].data[j]);
                              }
                          }
                      }

                      /* Remove from data all subcategories that have 0*/
                      let emptySubcategoriesToDelete: number[] = [];
                      this.subcategoriesValues.forEach((val, key) => {
                          if (val === 0) {
                              emptySubcategoriesToDelete.push(key);
                          }
                      });
                      /* Remove from the categories object that we send to the chart*/
                      for (let i = categories.length - 1; i >= 0; i--) {
                          for (let j = emptySubcategoriesToDelete.length - 1; j >= 0; j--) {
                              if (emptySubcategoriesToDelete[j] === i) {
                                  categories.splice(i, 1);
                              }
                          }
                      }
                      /* Remove 0 values from data only if entire column is 0 for that subcategory */
                      for (let i = 0; i < data.data.length; i++) {
                          for (let j = data.data[i].data.length - 1; j >= 0; j--) {
                              for (let k = emptySubcategoriesToDelete.length - 1; k >= 0; k--) {
                                  if (j === emptySubcategoriesToDelete[k]) {
                                      data.data[i].data.splice(j, 1);
                                  }
                              }
                          }
                      }

                      // @ts-ignore
                      return {
                          loading: false,
                          data: data,
                          error: null,
                          hasNoResults: categories.length === 0,
                      };
                  }),
                  startWith({
                      loading: true,
                      data: null,
                      error: null,
                      hasNoResults: true,
                  }),
                  catchError((error) => {
                      categories = [];
                      return of({
                          loading: false,
                          error,
                          data: null,
                          hasNoResults: true,
                      });
                  }),
              )
            : val;
    }
}
